import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Popover, Row, Col, Form, } from 'antd';
import { clsx } from 'clsx';
import { DownOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const lookUpHorizontalPosition = {
    right: 'positionRight',
    center: 'positionMiddle',
    left: 'positionLeft',
};
const lookUpVerticalPosition = {
    100: 'positionBottom',
    50: 'positionCenter',
    0: 'positionTop',
};
const alignments = ['left', 'center', 'right'];
const lines = [0, 50, 100];
const CaptionPosition = ({ form, onValuesChange, initialValue, }) => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const position = (_a = Form.useWatch('defaultCaptionPosition', form)) !== null && _a !== void 0 ? _a : {
        align: initialValue.align,
        line: initialValue.line,
    };
    const [open, setOpen] = useState(false);
    const getHorizontalPositionLocalization = () => {
        if (position.align === null) {
            throw new Error('align missing in format');
        }
        return lookUpHorizontalPosition[position.align];
    };
    const getVerticalPositionLocalization = () => {
        if (position.line === null) {
            throw new Error('line missing in format');
        }
        return lookUpVerticalPosition[position.line];
    };
    const handlePositioning = (align, line) => {
        form.setFieldValue('defaultCaptionPosition', { align, line });
        onValuesChange();
        setOpen(false);
    };
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const isSelected = (align, line) => {
        return position.align === align && position.line === line;
    };
    return (_jsx(Popover, { placement: "bottomLeft", arrow: false, trigger: ['click'], open: open, onOpenChange: handleOpenChange, content: (_jsxs(_Fragment, { children: [_jsxs(Row, { children: [_jsx(Col, { span: 8, children: _jsx("div", { className: styles.headerPosition, children: txt('positionLeft') }) }), _jsx(Col, { span: 8, children: _jsx("div", { className: styles.headerPosition, children: txt('positionMiddle') }) }), _jsx(Col, { span: 8, children: _jsx("div", { className: styles.headerPosition, children: txt('positionRight') }) })] }), lines.map((line) => (_jsx(Row, { children: alignments.map((align) => (_jsx(Col, { span: 8, children: _jsx(Button, { type: "default", className: clsx(styles.buttonPosition, isSelected(align, line) && styles.buttonPositionSelected), onClick: () => handlePositioning(align, line), children: txt(lookUpVerticalPosition[line]) }, `${align}-${line}`) }, `${align}-${line}`))) }, line)))] })), children: _jsx("div", { children: _jsxs("div", { className: styles.captionSelect, children: [_jsx("div", { className: styles.position, children: `${txt(getHorizontalPositionLocalization())} ${txt(getVerticalPositionLocalization())}` }), _jsx(DownOutlined, { className: styles.arrow })] }) }) }));
};
export default CaptionPosition;
